//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.FilterItem
import com.tixforgigs.apax.models.OrganizerFilterType

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The template filter model
* 
* @param organizerFilterType 
* @param artists ...
* @param dateFrom ...
* @param dateTo ...
* @param excludedEvents ...
* @param genres ...
* @param organizerEmails List of emails.
* @param relativeDays ...
* @param venues ...
*/
@Serializable

data class TemplateFilter (


      @SerialName(value = "organizerFilterType") @Required val organizerFilterType: OrganizerFilterType,


      /* ... */
    @SerialName(value = "artists") val artists: kotlin.collections.List<FilterItem>? = null,


      /* ... */
    @SerialName(value = "dateFrom") val dateFrom: kotlin.time.Instant? = null,


      /* ... */
    @SerialName(value = "dateTo") val dateTo: kotlin.time.Instant? = null,


      /* ... */
    @SerialName(value = "excludedEvents") val excludedEvents: kotlin.collections.List<FilterItem>? = null,


      /* ... */
    @SerialName(value = "genres") val genres: kotlin.collections.List<FilterItem>? = null,


      /* List of emails. */
    @SerialName(value = "organizerEmails") val organizerEmails: kotlin.collections.List<kotlin.String>? = null,


      /* ... */
    @SerialName(value = "relativeDays") val relativeDays: kotlin.Int? = null,


      /* ... */
    @SerialName(value = "venues") val venues: kotlin.collections.List<FilterItem>? = null


) {




  }

